import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { BRAND_NAME } from '../../config/brand';
import type { SeoBreadcrumb } from './SEOHead';

type BreadcrumbNavProps = {
  items: SeoBreadcrumb[];
  className?: string;
};

/**
 * Visible breadcrumb trail (complements BreadcrumbList JSON-LD in SEOHead).
 * Mobile-first: wraps, compact tap targets.
 */
const BreadcrumbNav: React.FC<BreadcrumbNavProps> = ({ items, className = '' }) => {
  if (!items.length) return null;

  const crumbs = [{ name: BRAND_NAME, path: '/' }, ...items];

  return (
    <nav
      aria-label="مسار التنقل"
      className={`mb-4 overflow-x-auto text-sm text-gray-600 ${className}`}
      dir="rtl"
    >
      <ol className="flex min-w-0 flex-wrap items-center gap-1">
        {crumbs.map((item, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <li key={`${item.path}-${index}`} className="inline-flex min-h-9 items-center gap-1">
              {index > 0 && (
                <ChevronLeft className="h-3.5 w-3.5 shrink-0 text-gray-400" aria-hidden />
              )}
              {isLast ? (
                <span className="line-clamp-1 font-semibold text-green-900" aria-current="page">
                  {item.name}
                </span>
              ) : (
                <Link
                  to={item.path}
                  className="line-clamp-1 rounded px-1 py-1.5 text-green-700 hover:text-gold-600 hover:underline"
                >
                  {item.name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbNav;
